import { Pipe, PipeTransform } from '@angular/core';
import { StringReplacerItem } from '@nrwl/rx-models';

@Pipe({ name: 'stringReplacer' })
export class StringReplacerPipe implements PipeTransform {
  transform(data: any, replacers: StringReplacerItem[]): string {
    replacers.forEach((item) => {
      data = data.replace(item.from, item.to);
    });
    return data;
  }
}
